export enum DisputeChargebackStatus {
    SUCCESS = "SUCCESS",
    WARNING = "WARNING",
    ERROR = "ERROR",
    SKIP = "SKIP",
}

export const disputeChargebackStatusList = [
    { value: DisputeChargebackStatus.SUCCESS, label: "Success" },
    { value: DisputeChargebackStatus.ERROR, label: "Error" },
    { value: DisputeChargebackStatus.WARNING, label: "Warning" },
    { value: DisputeChargebackStatus.SKIP, label: "Skip" },
];

